import React from 'react';
import { InvestorDeck } from './pages/InvestorDeck';
export function App() {
  return <InvestorDeck data-id="element-0" />;
}